import(/* webpackMode: "eager" */ "/home/runner/work/apps_glu_former_site/apps_glu_former_site/frontend/web/src/app/page.jsx");
